<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <!-- <el-table-column type="selection" width="50"> </el-table-column> -->
        <!-- <el-table-column prop="StudentId" label="学生ID" width="">
          </el-table-column> -->
        <el-table-column prop="Name" label="姓名" width="">
        </el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width="">
        </el-table-column>

        <!-- 返校日期 -->
        <el-table-column prop="ReturnDate" label="返校日期" width="">
          <template slot-scope="scope">
            {{ formatDate(scope.row.ReturnDate) }}
          </template>
        </el-table-column>

        <!-- 返校开始时间 -->
        <el-table-column prop="ReturnStartTime" label="开始时间" width="">
          <template slot-scope="scope">
            {{ formatTime(scope.row.ReturnStartTime) }}
          </template>
        </el-table-column>

        <!-- 返校结束时间 -->
        <el-table-column prop="ReturnEndTime" label="结束时间" width="">
          <template slot-scope="scope">
            {{ formatTime(scope.row.ReturnEndTime) }}
          </template>
        </el-table-column>

        <el-table-column prop="Reason" label="返校原因" min-width="120">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="dark">
              <div slot="content" style="white-space: pre-wrap; word-break: break-all; max-width: 400px;">{{
                scope.row.Reason || '' }}</div>
              <div
                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block; max-width: 100%;">
                {{ scope.row.Reason || '-' }}</div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="ApprovalStatus" label="审批状态" width="">
          <template slot-scope="scope">
            <el-tag :type="getApprovalStatusType(scope.row.ApprovalStatus)">{{
              getApprovalStatusText(scope.row.ApprovalStatus) }}</el-tag>
          </template>
        </el-table-column>

        <!-- 审批时间 -->
        <el-table-column prop="ApprovalTime" label="审批时间" width="">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.ApprovalTime) }}
          </template>
        </el-table-column>

        <!-- 审批意见 -->
        <el-table-column prop="ApprovalComment" label="审批意见" min-width="">
        </el-table-column>

        <el-table-column prop="CreateTime" label="申请时间" width="">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.CreateTime) }}
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="pageSize" :total="total" style="float: right"></el-pagination>
      </el-col>
    </section>
  </section>
</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getReturnSchoolApplicationPage, exportReturnSchoolApplication } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
        {
          label: '开始日期',
          key: 'startDate',
          type: 'date'
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date'
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      isResouceShow: 0,
      DepartmentId: 0
    };
  },
  methods: {
    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return dateTime;
      }
    },
    // 格式化日期
    formatDate(date) {
      if (!date) return '-';
      try {
        const dateObj = new Date(date);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      } catch (error) {
        return date;
      }
    },

    // 格式化时间
    formatTime(time) {
      if (!time) return '-';
      try {
        // 处理 TimeSpan 格式
        if (typeof time === 'string' && time.includes(':')) {
          return time;
        }

        // 处理日期对象
        const date = new Date(time);
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
      } catch (error) {
        return time;
      }
    },

    // 获取审批状态类型
    getApprovalStatusType(status) {
      const typeMap = {
        0: 'warning',       // 待审批
        1: 'success',       // 已通过
        2: 'danger'         // 已拒绝
      };
      return typeMap[status] || 'default';
    },

    // 获取审批状态文本
    getApprovalStatusText(status) {
      const statusMap = {
        0: '待审批',
        1: '已通过',
        2: '已拒绝'
      };
      return statusMap[status] || '未知状态';
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      }
      this.listLoading = true;
      testapi();
      getReturnSchoolApplicationPage(para).then((res) => {
        this.total = res.data.response.dataCount
        this.pageSize = res.data.response.PageSize
        this.users = res.data.response.data
        this.listLoading = false
      });
    },

    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          intPageSize: this.pageSize,
          ...this.filters,
        };

        var fileName = "返校申请记录";
        const response = await exportReturnSchoolApplication(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },

  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>